import { Controller } from 'react-hook-form';
import { NumericFormat } from 'react-number-format';
import AppTextInput from 'components/FormElements/AppTextInput';
import { Row } from 'components/SectionedTable';
import useConsiderationCalculations, {
  ConsiderationPerUnitType,
} from '../../hooks/useConsiderationCalculations';

type CashConsiderationCellProps = {
  colIdx: number;
  row: Row;
  control: any;
  currencySymbol: string;
  disabled: boolean;
};

const CashConsiderationCell: React.FC<CashConsiderationCellProps> = ({
  colIdx,
  row,
  control,
  currencySymbol,
  disabled,
}) => {
  const name = `holdingClassRealisation.${colIdx}.cashConsiderationAmounts.${row.key}`;

  const { onManualConsiderationChange, setFieldFocus } =
    useConsiderationCalculations();

  const onValueChange = (value: number, onChange: (value: number) => void) => {
    onChange(+value);
    onManualConsiderationChange(
      +value,
      row.key as ConsiderationPerUnitType,
      colIdx,
    );
  };

  return (
    <Controller
      name={name}
      control={control}
      render={({
        field: { ref, onChange, ...rest },
        fieldState: { error },
      }) => (
        <NumericFormat
          {...rest}
          inputRef={ref}
          onValueChange={({ value }) => {
            onValueChange(+value, onChange);
          }}
          onFocus={() => setFieldFocus(row.key as ConsiderationPerUnitType)}
          disabled={disabled}
          decimalScale={10}
          allowNegative={false}
          thousandSeparator
          prefix={currencySymbol}
          customInput={AppTextInput}
          error={!!error}
          helperText={error?.message}
          size="small"
          fullWidth
        />
      )}
    />
  );
};

export default CashConsiderationCell;
